<script setup lang="ts">
import { MessageSquareIcon, SmartphoneIcon } from 'lucide-vue-next';
import accountManager from '/assets/account-manager.png';

const { inline = false } = defineProps<{
  inline?: boolean
}>()

const { t } = useI18n()
</script>

<template>
  <div v-if="inline">
    <Card size="sm">
      <template #content>
        <div class="flex items-center gap-4">
          <div class="flex items-center gap-2">
            <Avatar
              :src="accountManager"
              class="ml-auto"
              status="online"
              size="w-16"
              shape="circle"
            />
            <div class="flex flex-col gap-1">
              <span class="text-lg font-semibold">Laure de Bokay</span>
              <span class="text-primary text-xs">laure@cinqo.fr</span>
            </div>
          </div>
          <div>
            <div class="card-actions flex flex-col gap-2">
              <a
                href="https://calendly.com/laure-cinqo/30min"
                target="_blank"
                class="flex w-full"
              >
                <EButton
                  class="btn-primary btn-outline grow"
                  size="sm"
                  :label="t('global.book_a_call')"
                  :icon="SmartphoneIcon"
                />
              </a>
              <EButton
                class="btn-primary btn-outline btn-block"
                size="sm"
                :label="t('global.chat')"
                :icon="MessageSquareIcon"
                @click="toggleCrispChat()"
              />
            </div>
          </div>
        </div>
      </template>
    </Card>
  </div>
  <div v-else class="card shadow-lg bg-base-100 card-normal md:w-80 w-full">
    <div class="card-body">
      <h2 class="card-title flex gap-4">
        <div>
          <span class="text-sm">{{ t('global.account_manager') }}</span>
          <br />
          <span class="text-xl">Laure de Bokay</span>
          <br />
          <span class="text-primary text-xs">laure@cinqo.fr</span>
          <div class="text-xs">
            <a class="text-primary underline underline-offset-2 cursor-pointer" href="tel:0670561415">
              06 70 56 14 15
            </a>
          </div>
        </div>
        <Avatar
          :src="accountManager"
          class="ml-auto"
          status="online"
          size="w-16"
          shape="circle"
        />
      </h2>

      <p class="flex flex-wrap leading-7">
        {{ t('global.account_manager_content') }}
      </p>

      <div class="card-actions flex flex-wrap gap-2">
        <a
          href="https://calendly.com/laure-cinqo/30min"
          target="_blank"
          class="flex flex-1 min-w-[180px]"
        >
          <EButton
            class="btn-primary btn-outline w-full"
            size="sm"
            :label="t('global.book_a_call')"
            :icon="SmartphoneIcon"
          />
        </a>
        <EButton
          class="btn-primary btn-outline flex-1 min-w-[180px]"
          size="sm"
          :label="t('global.chat')"
          :icon="MessageSquareIcon"
          @click="toggleCrispChat()"
        />
      </div>
    </div>
  </div>
</template>
